import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA8NhiB1JynFonn_-6Ohp6EO3ikKsOkNH0",
  authDomain: "cricwager-4ab5c.firebaseapp.com",
  projectId: "cricwager-4ab5c",
  storageBucket: "cricwager-4ab5c.firebasestorage.app",
  messagingSenderId: "921226386138",
  appId: "1:921226386138:web:72050830444666bf8763e3",
  measurementId: "G-VLC51FTD74"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
